(() => {
  const o = document.querySelector(".sticky_button");
  if (o) {
    const e = document.querySelector(".footer");
    window.addEventListener("scroll", () => {
      console.log(window.pageYOffset),
        console.log(e.offsetTop),
        window.pageYOffset + window.innerHeight >= e.offsetTop
          ? (console.log("footer"), o.classList.add("hidden"))
          : o.classList.remove("hidden");
    });
  }
})();
